import CrudCustom from '../../../libs/custom/CrudCustom';

let PPh21A1Service = new CrudCustom('/p-ph-21-a1s');
export default PPh21A1Service;
